import React from 'react'

export function NoImageWrap({ style, noSize, svgClass, ...rest }) {
  return (
    <div
      style={{
        width: '100%',
        // height: '219px',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        overflow: 'hidden',
        ...style,
      }}
      {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width="306" height="219" viewBox="0 0 306 219" className={svgClass}>
        <g fill="none" fillRule="evenodd">
          <g>
            <g transform="translate(-491 -316) translate(491 316)">
              <rect width="305" height="218" x=".5" y=".5" fill="#B8B8B8" stroke="#979797" rx="1" />
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M127.778 83.464c2.076-.065 4.05.99 5.278 2.824l48.636 72.307 20.95-21.835c1.317-1.406 3.127-2.115 4.96-1.942 1.831.173 3.504 1.211 4.58 2.843l20.39 30.316c1.431 2.132 1.627 4.97.505 7.314-1.121 2.343-3.365 3.782-5.78 3.706H79.482c-2.346.065-4.532-1.298-5.677-3.541-1.146-2.243-1.063-4.996.215-7.151l48.636-81.69c1.13-1.907 3.045-3.085 5.122-3.15zM204.178 41c11.686 0 21.159 11.882 21.159 26.538 0 14.657-9.473 26.539-21.158 26.539S183.02 82.195 183.02 67.538c0-14.656 9.473-26.538 21.158-26.538z"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}
